import { styled } from "@mui/material/styles";
import React from "react";

const Error = styled("span")(({ theme }) => ({
  width: "100%",
  fontSize: "12px",
  alignItems: "start",
  color: "#EB001B",
  lineHeight: "15px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "8px"
  }
}));

const ErrorMsg = ({ msg }) => {
  return <Error>{msg}</Error>;
};

export default ErrorMsg;
